import request from '@/utils/request'

/**
 * 创建报名记录
 * @param {Object} data 报名数据
 * @returns {Promise}
 */
export function createRegistration(data) {
  return request({
    url: '/registration',
    method: 'post',
    data
  })
}

/**
 * 获取报名列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getRegistrations(params) {
  return request({
    url: '/registrations',
    method: 'get',
    params
  })
}

/**
 * 获取单个报名详情
 * @param {Number} id 报名ID
 * @returns {Promise}
 */
export function getRegistration(id) {
  return request({
    url: `/registration/${id}`,
    method: 'get'
  })
}

/**
 * 导出报名列表为Excel
 * @param {Object} params 查询参数
 * @returns {Promise<Blob>}
 */
export function exportRegistrations(params) {
  return request({
    url: '/registrations/export',
    method: 'get',
    params,
    responseType: 'blob'
  })
}